import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  TRACE_DATA,
  GET_CLAIMS_DATA,
} from "../actionTypes";

const user = localStorage.getItem("token");

const initialState = user
  ? { isLoggedIn: true, user }
  : { isLoggedIn: false, user: null };

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case TRACE_DATA:
      return {
        ...state,
        traceData: payload.moduleTraceData,
      };
    case GET_CLAIMS_DATA:
      return {
        ...state,
        claimsData: payload.claimsData,
      };
    default:
      return state;
  }
};

export default authReducer;
